<script setup>
import {ref} from "vue"

const props = defineProps({
  // 标题
  title: {
    type: String,
    default: '信息'
  },
  // 子标题
  subTitle: {
    type: String,
    default: ''
  },
  // 底部分割线
  isShowDivider: {
    type: Boolean,
    default: true
  },
  // 标题分割线
  isShowTitleLine: {
    type: Boolean,
    default: false
  },
  // 是否内容缩进
  isRetract: {
    type: Boolean,
    default: true
  },
  isCollapsed: {
    type: Boolean,
    default: false
  },
  // 是否展示
  show: {
    type: Boolean,
    default: true
  },
  // 标题后示例是否展示
  isShowExamples: {
    type: Boolean,
    default: false
  }
})

// 缩放
const collapsed = ref(false)

const emit = defineEmits(['clickTitleAfter'])

// 点击标题后按钮
const handleClick = () => {
  emit('clickTitleAfter')
}
</script>

<template>
  <div v-show="show">
    <div class="ytCard_box">
      <div class="ytCard_title_box">
        <div class="flex_center flex_left">
          <div class="flex_bt">
            <span class="ytCard_title" v-text="props.title" ></span>
            <v-btn v-if="isCollapsed" variant="text" :icon="collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'" @click="collapsed = !collapsed"></v-btn>
          </div>
          <div v-show="props.isShowExamples">
            <el-link style="color: #409eff;" @click="handleClick">示例</el-link>
          </div>
        </div>
        <span class="ytCard_subTitle" v-text="props.subTitle" ></span>
        <v-divider style="margin-bottom: 24px" v-if="isShowTitleLine"/>
      </div>
      <transition name="el-zoom-in-top">
        <div :style="isRetract ? 'margin-left: 64px' : ''" v-if="!collapsed">
          <slot name="container"></slot>
        </div>
      </transition>
    </div>
    <v-divider style="margin-bottom: 24px" v-if="isShowDivider"/>
  </div>
</template>

<style scoped>
.ytCard_box {
  width: 100%;
  text-align: left;
  margin-bottom: 24px;
  .ytCard_title_box{
    margin-bottom: 20px;
    .ytCard_title {
      font-size: 32px;
      font-weight: bolder;
      margin-right: 20px;
    }
    .ytCard_subTitle {
      font-size: 20px;
      font-weight: bolder;
      text-align: left;
      margin-bottom: 20px;
      color: #a7a7a7;
    }
  }

}

</style>
